module.exports = __webpack_public_path__ + "img/ewptx_badge.e4c79385.png";